var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCmPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_grupcmentarza_"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "96.05 14.08 96.05 42.52 138.15 76.22",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "109.83 13.32 109.83 32.99 138.27 56.17",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.61 13.32 123.61 23.72 137.9 35.5",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "180.25 14.08 180.25 42.52 138.15 76.22",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "166.47 13.32 166.47 32.99 138.02 56.17",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "152.68 13.32 152.68 23.72 138.4 35.5",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.27,
    y1: 13.32,
    x2: 138.27,
    y2: 91.26,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.79,
    y1: 13.2,
    x2: 98.43,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.45,
    y1: 13.2,
    x2: 112.09,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.36,
    y1: 13.2,
    x2: 126,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.77,
    y1: 13.2,
    x2: 140.4,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.3,
    y1: 13.2,
    x2: 154.94,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.09,
    y1: 13.2,
    x2: 168.72,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.49,
    y1: 13.2,
    x2: 182.13,
    y2: 13.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.65 27.61 122.49 53.17 154.31 53.17 138.65 27.61",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.84
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.15 62.56 154.31 37 122.49 37 138.15 62.56",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.32,102.25c-1.75-.45-3.43-1.07-5.05-1.84l3.26-44.73,17.79-1.75,1.5,1.13s1.25.38,1.38.88.13,1,.13,1l1.25.5,1.38,4.51v1.38l2,2,1,1.38s.25,3.01.5,3.51,1.63,4.64,1.63,4.64l.63,5.64,1.25,9.15s-.38,1.13-.38,1.88,1,5.89,1,5.89c-2.35,1.15-4.63,2.12-6.84,2.92",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,54.67c-.18-1.94-3.68-1.07-3.51.88l3.51-.88Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.29 54.55 94.92 52.92 96.68 53.42 97.43 53.67 93.29 54.55",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.18 53.79 101.19 52.17 102.31 53.17 100.18 53.79",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,53.29l.73-.48c.73-.48,1.64-.59,2.46-.29l1.08.4",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.68,53.42l.21-.21c.72-.72,1.77-.99,2.75-.71l1.05.3",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "82.27 100.4 79.39 97.15 80.01 100.53 77.38 99.78 76.63 101.28 73.87 101.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8,103.79s2.26-5.14,2.26-4.64-.25,3.51-.25,3.51l2.63-2.38-.63,2.51,3.51-.75",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.97 89.63 118.23 87.62 117.22 90.63 119.86 88.13",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.48,
    y1: 89.63,
    x2: 124.24,
    y2: 89.63,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "137.02 92.39 134.89 89.5 135.02 91.76 132.51 90.63 133.01 92.26 129.5 91.88",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.4,
    y1: 92.51,
    x2: 141.66,
    y2: 88.75,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "140.91 92.76 142.91 90.63 142.66 92.76 145.17 92.26",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97 56.05 93.23 63.03 101.47 62.22 97 56.05",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.23 64.69 101 57.71 92.76 58.53 97.23 64.69",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.41,
    y1: 69.08,
    x2: 104.95,
    y2: 67.95,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.29,
    y1: 73.47,
    x2: 103.07,
    y2: 72.59,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.67,
    y1: 77.6,
    x2: 103.82,
    y2: 76.6,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.42,
    y1: 81.36,
    x2: 105.2,
    y2: 80.23,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.91,84.78c.47,5.98,11.1,5.39,10.62-.58",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,84.89c.31,3.55,7.39,3.12,7.08-.43",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.76,84.88c.17,1.38,3.55,1.11,3.39-.28",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.3,
    y1: 84.49,
    x2: 98.81,
    y2: 91.01,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.8,
    y1: 91.63,
    x2: 101.06,
    y2: 91.26,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.4,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.02,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,9.6c0-.83-1.5-3.38-1.5-3.38,0,0-1.5,2.55-1.5,3.38s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.74
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmPop);
export default __webpack_public_path__ + "static/media/cm_pop.91f530cc9624639c4a9a7703934b069b.svg";
export { ForwardRef as ReactComponent };